import { createTheme } from '@mui/material/styles';

// Define typography settings in one place
const typographySettings = {
  fontFamily: 'Open Sans, sans-serif',
  h1: {
    fontSize: '1.5rem',
    '@media (min-width:600px)': {
      fontSize: '2.5rem',
    },
    '@media (min-width:960px)': {
      fontSize: '3.5rem',
    },
    '@media (min-width:1280px)': {
      fontSize: '3.25rem',
    },
  },
  h2: {
    fontSize: '1.5rem',
    '@media (min-width:600px)': {
      fontSize: '1.75rem',
    },
    '@media (min-width:960px)': {
      fontSize: '2.25rem',
    },
    '@media (min-width:1280px)': {
      fontSize: '2.75rem',
    },
  },
  h3: {
    fontSize: '1.25rem',
    '@media (min-width:600px)': {
      fontSize: '1.5rem',
    },
    '@media (min-width:960px)': {
      fontSize: '1.75rem',
    },
    '@media (min-width:1280px)': {
      fontSize: '2rem',
    },
  },
  h6: {
    fontSize: '1rem',
    '@media (min-width:600px)': {
      fontSize: '1rem',
    },
    '@media (min-width:960px)': {
      fontSize: '1.25rem',
    },
    '@media (min-width:1280px)': {
      fontSize: '1.5rem',
    },
  },
  body1: {
    lineHeight: '2',
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#B8860B',
    },
    secondary: {
      main: '#B8860B',
    },
  },
  typography: typographySettings, // Reuse typography settings
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          borderRadius: '9999px',
        },
        contained: {
          background: 'linear-gradient(135deg, #FFD700 0%, #B8860B 100%)',
          boxShadow: '0 4px 15px 0 rgba(184, 134, 11, 0.3)',
          color: 'black',
          '&:hover': {
            background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
            boxShadow: '0 6px 20px 0 rgba(184, 134, 11, 0.4)',
            color: 'black',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: '9999px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          color: 'black',
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFD700',
    },
    secondary: {
      main: '#FFD700',
    },
  },
  typography: typographySettings, // Reuse typography settings
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          borderRadius: '9999px',
        },
        contained: {
          background: 'linear-gradient(135deg, #FFD700 0%, #B8860B 100%)',
          boxShadow: '0 4px 15px 0 rgba(255, 215, 0, 0.3)',
          '&:hover': {
            background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
            boxShadow: '0 6px 20px 0 rgba(255, 215, 0, 0.4)',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: '9999px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          backgroundImage: 'none',
          boxShadow: 'none',
          color: 'white',
        },
      },
    },
  },
});
